/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-text-muted-color);
  --border-radius: var(--nve-ref-border-radius-full);
  --padding: 0;
  --line-height: 0;
  --gap: 0;
  --height: var(--nve-ref-size-800);
  --width: var(--nve-ref-size-800);
  --font-size: calc(var(--width) / 2.3);
}

/* override base button inline style */
:host([container*='inline']) {
  --height: var(--nve-ref-size-800);
  --line-height: 0;
}

:host([size='sm']) {
  --padding: 0;
  --height: var(--nve-ref-size-700);
  --width: var(--nve-ref-size-700);
}

:host([size='lg']) {
  --width: var(--nve-ref-size-1000);
  --height: var(--nve-ref-size-1000);
  --padding: 0;
}

[internal-host] {
  font-size: var(--font-size);
}

/* disable pseudo element on base button */
[internal-host]::after {
  display: none !important;
}

nve-icon {
  --color: var(--_icon-color);
  pointer-events: none;
}

::slotted(a) {
  text-decoration: none !important;
  color: var(--color) !important;
  outline: 0;
}

::slotted(a)::after {
  display: block;
  content: ' ';
  inset: 0;
  position: absolute;
}
